import { TextField, TextFieldProps } from "@mui/material";
import { forwardRef } from "react";

const Input = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  const { slotProps, ...rest } = props;

  return (
    <TextField
      ref={ref}
      fullWidth
      variant="outlined"
      {...rest}
      slotProps={slotProps}
      sx={{
        marginY: "0.4rem",
        ...props.sx,
      }}
    />
  );
});

Input.displayName = "Input";

export default Input;